{
  "app.title": "AoM Retold · Build Orders",
  "app.short": "Build Orders",
  "nav.library": "Biblioteca",
  "nav.settings": "Configurações",
  "nav.back": "Voltar",
  "footer.legal": "Age of Mythology © Microsoft Corporation. Este site não é afiliado nem endossado pela Microsoft.",
  "footer.fan": "Projeto de fã, sem fins lucrativos.",
  "footer.reference": "* Os resultados são uma referência, não uma medição exata: favor dos Oráculos, deslocamento dos aldeões e outros fatores variam de partida para partida.",
  "footer.source": "Código aberto no GitHub",
  "storage.unavailable": "Não foi possível salvar no navegador. Exporte suas builds para não perdê-las.",
  "loading": "Carregando…",
  "error.data": "Erro ao carregar os dados do jogo",
  "library.mine": "Minhas builds",
  "library.presets": "Builds padrão",
  "library.empty": "Nenhuma build ainda",
  "library.new": "Nova build",
  "library.import": "Importar",
  "library.exportAll": "Exportar todas",
  "library.drop": "Solte arquivos .json aqui",
  "library.filters": "Filtros",
  "library.all": "Todos",
  "library.noMatch": "Nada com esses filtros",
  "oss.title": "Código aberto",
  "oss.text": "Este app é gratuito, feito por jogadores, e todo o código está no GitHub. Achou um erro, tem uma ideia ou quer ajudar com o código ou os números do jogo? Chega mais.",
  "oss.repo": "Ver no GitHub",
  "oss.issue": "Sugerir ou reportar",
  "card.open": "Abrir",
  "card.duplicate": "Duplicar",
  "card.duplicateToEdit": "Duplicar para editar",
  "card.export": "Exportar",
  "card.exportDashboard": "Exportar para o dashboard",
  "share.copy": "Copiar link",
  "share.copied": "Link copiado: quem abrir vê a build e pode salvar uma cópia.",
  "share.copyManually": "Copie o link:",
  "share.banner": "Build compartilhada",
  "share.save": "Salvar nas minhas builds",
  "share.saved": "Build salva nas suas builds",
  "share.invalid": "Link inválido ou incompleto.",
  "share.loading": "Abrindo a build…",
  "propose.menu": "Propor como build padrão",
  "propose.confirm": "A build abre no GitHub como uma proposta pública (é preciso ter conta no GitHub). Um robô confere a build e, se ela passar, vai para revisão; aprovada, ela aparece para todos como build padrão.",
  "propose.go": "Abrir no GitHub",
  "propose.hasErrors": "A build tem erros: corrija-os antes de propor.",
  "card.delete": "Apagar",
  "card.play": "Modo partida",
  "mode.view": "Visão geral",
  "mode.edit": "Editar",
  "mode.play": "Modo partida",
  "overview.full": "Visão completa",
  "card.confirmDelete": "Apagar “{name}”?",
  "card.readonly": "Somente leitura",
  "confirm.yes": "Sim",
  "confirm.no": "Não",
  "confirm.cancel": "Cancelar",
  "type.rush": "Rush",
  "type.eco": "Economia",
  "type.timing": "Timing",
  "type.water": "Água",
  "type.other": "Outro",
  "import.ok.one": "{count} build importada",
  "import.ok.other": "{count} builds importadas",
  "import.error": "Arquivo inválido: {detail}",
  "import.newer": "Este arquivo é de uma versão mais nova do app (v{version}). Atualize a página.",
  "import.conflict": "Já existe uma build com o id de “{name}”.",
  "import.replace": "Substituir",
  "import.keepBoth": "Manter as duas",
  "import.suffix": "(importada)",
  "editor.name": "Nome",
  "editor.author": "Autor",
  "editor.type": "Tipo",
  "editor.pantheon": "Panteão",
  "editor.god": "Deus maior",
  "editor.minors": "Deuses menores",
  "editor.objective": "Objetivo",
  "editor.end": "Fim da build",
  "editor.actions": "Ações",
  "editor.add": "Adicionar ação",
  "editor.result": "Resultado",
  "editor.settings": "Simulação",
  "editor.efficiency": "Eficiência",
  "editor.tick": "Tick (s)",
  "editor.foodChain": "Cadeia de comida",
  "editor.oracleRate": "Favor por Oráculo (/min)",
  "editor.norseFavor": "Favor nórdico (/min)",
  "editor.readonly": "Build padrão: somente leitura",
  "editor.empty": "Adicione ações pela paleta",
  "editor.matchups": "Confrontos",
  "editor.milestones": "Marcos",
  "editor.addMilestone": "Marcar como marco",
  "editor.removeMilestone": "Remover marco",
  "picker.search": "Buscar ação, evento ou tempo…",
  "picker.filter": "Mostrar",
  "picker.all": "Tudo",
  "picker.end": "Termina",
  "picker.start": "Começa",
  "picker.empty": "Nada encontrado",
  "picker.never": "Não acontece",
  "picker.choose": "Escolher ação…",
  "milestone.add": "Adicionar marco",
  "milestone.remove": "Remover marco",
  "result.clickedAt": "Clique: {t}",
  "help.milestone.add": "Escolha um momento da build para acompanhar o tempo e os recursos nele: quando uma ação **termina** (Era alcançada, prédio pronto, unidades prontas…) ou quando **começa**.",
  "editor.saved": "Salvo",
  "editor.notFound": "Build não encontrada",
  "editor.changePantheon": "Trocar o panteão limpa as ações. Continuar?",
  "editor.reset": "Padrão",
  "palette.pick": "Escolha",
  "palette.allAges": "Todas as Eras",
  "action.train": "Treinar",
  "action.train.auto": "Produção automática",
  "action.build": "Construir",
  "action.research": "Pesquisar",
  "action.age": "Subir de Era",
  "action.move": "Mover aldeões",
  "action.power": "Poder divino",
  "action.timeShift": "Time Shift",
  "action.promote": "Promover",
  "action.event": "Evento manual",
  "row.when": "Quando",
  "row.asap": "Assim que der, após…",
  "row.after": "Depois de…",
  "row.afterDone": "Quando termina",
  "row.afterStart": "Quando começa",
  "row.atTime": "No tempo",
  "row.delay": "Atraso (s)",
  "row.count": "Quantidade",
  "row.trainMode": "Modo",
  "row.trainMode.count": "Quantidade fixa",
  "row.trainMode.auto": "Fila automática",
  "row.duration": "Por (s)",
  "row.rally": "Destino",
  "row.builder": "Construtor",
  "row.builderNew": "Aldeão novo de…",
  "row.builderFrom": "Tirar de",
  "row.builderSame": "Mesmo construtor de…",
  "row.then": "Depois vai para",
  "row.from": "De",
  "row.to": "Para",
  "row.nearManor": "Mansões perto",
  "row.target": "Alvo",
  "row.trainAt": "Prédio",
  "row.lose": "Perder",
  "row.gainFavor": "Ganhar favor",
  "row.gainResource": "Ganhar recurso",
  "row.note": "Nota",
  "row.up": "Subir",
  "row.down": "Descer",
  "row.drag": "Arrastar para reordenar",
  "row.remove": "Remover",
  "row.duplicate": "Duplicar ação",
  "row.edit": "Editar",
  "row.unit": "Unidade",
  "row.any": "Qualquer",
  "row.minor": "Deus menor",
  "row.started": "Começou {t}",
  "row.done": "Terminou {t}",
  "row.notStarted": "Não começou",
  "row.none": "—",
  "result.timeline": "Linha do tempo",
  "result.resources": "Recursos",
  "result.population": "População",
  "result.warnings": "Avisos",
  "result.noWarnings": "Sem avisos",
  "result.used": "Usada",
  "result.cap": "Limite",
  "result.time": "Tempo",
  "result.pop": "Pop.",
  "result.alloc": "Aldeões: comida/madeira/ouro/favor",
  "result.good": "Bom",
  "result.neutral": "Neutro",
  "result.bad": "Ruim",
  "result.lowConfidence": "Dado de baixa confiança",
  "result.clicked": "Clique",
  "result.reached": "Chegou",
  "res.food": "Comida",
  "res.wood": "Madeira",
  "res.gold": "Ouro",
  "res.favor": "Favor",
  "res.idle": "ocioso",
  "res.any": "qualquer recurso",
  "word.or": " ou ",
  "step.train": "Treinar {count} {unit}",
  "step.ready": "+1 {unit} → {to}",
  "step.readyMilitary": "+1 {unit}",
  "step.build": "Construir {building}",
  "step.builderFrom.one": "de {from}",
  "step.builderFrom.other": "{count} de {from}",
  "step.byNew": "{unit} novo",
  "step.bySame": "mesmo construtor",
  "step.byFrom": "1 {unit} de {from}",
  "step.buildDone": "{building} ✓ · construtor → {to}",
  "step.buildDoneAlone": "{building} ✓",
  "step.research": "Pesquisar {research}",
  "step.researchDone": "{research} ✓",
  "step.age": "Pesquisar {age} ({minor})",
  "step.ageDone": "{age} ✓",
  "step.ageDoneFree": "{age} ✓ · {free} grátis",
  "step.move": "{count} {worker} de {from} → {to}",
  "step.power": "{power}",
  "step.powerOn": "{power} → {target}",
  "step.timeShift": "Time Shift: {building} ({seconds} s)",
  "step.timeShiftDone": "{building} chegou",
  "step.promote": "Promover {count} {unit} → {to}",
  "step.autoTrain": "Produção automática de {unit}",
  "step.autoTrainFor": "Produção automática de {unit} por {time}",
  "step.autoTrainUntil": "Produção automática de {unit} até {until}",
  "step.autoTrainEnd": "Fim da produção automática de {unit}",
  "step.lose": "−{count} {unit}",
  "step.gain": "+{count} {resource}",
  "warn.noResource": "Faltou {resource} ({missing}); esperou {waited} s",
  "warn.queueBusy": "Fila ocupada: {building}; esperou {waited} s",
  "warn.popCapped": "População no limite ({unit}); esperou {waited} s",
  "warn.missingRequirement": "Pré-requisito faltando: {req}",
  "warn.waitingRequirement": "Esperou {req}: {waited} s",
  "warn.lowConfidenceData": "Dado de baixa confiança: {id}",
  "warn.unknownId": "Id desconhecido: {id}",
  "warn.unknownAction": "Ação de referência não existe: {id}",
  "warn.noBuilding": "Nenhum prédio pode fazer isso",
  "warn.buildingNotReady": "{building} não está pronto; esperou {waited} s",
  "warn.noWorker": "Sem aldeão em {from}; esperou {waited} s",
  "warn.noBuilder": "Construtor indisponível ({id})",
  "warn.waitingBuilder": "Esperando construtor",
  "warn.notEnoughWorkers": "Só {moved} de {wanted} aldeões em {from}",
  "warn.notEnoughUnits": "Só havia {removed} de {wanted}: {unit}",
  "warn.buildLimit": "Limite atingido: {building}",
  "warn.alreadyResearched": "Já pesquisado: {id}",
  "warn.invalidMinor": "{minor} não está disponível para {age}",
  "warn.alreadyInAge": "Já está na Era: {age}",
  "warn.powerUnavailable": "Poder indisponível: {power}",
  "warn.powerNoUses": "{power} sem usos restantes",
  "warn.powerCooldown": "{power} em recarga; esperou {waited} s",
  "warn.missingTarget": "{power} precisa de um alvo",
  "warn.cannotPromote": "Não pode ser promovido: {unit}",
  "warn.noUnitToPromote": "Nada para promover ({unit}); esperou {waited} s",
  "warn.cannotGather": "{unit} não coleta {source}",
  "warn.idleWorkers": "Aldeões ociosos por {waited} s",
  "warn.neverStarted": "A ação nunca começou",
  "level.info": "Info",
  "level.delay": "Atraso",
  "level.error": "Erro",
  "match.start": "Iniciar",
  "match.pause": "Pausar",
  "match.reset": "Zerar",
  "match.minus5": "−5 s",
  "match.plus5": "+5 s",
  "match.countdown": "Contagem regressiva (s)",
  "match.sound": "Som de contagem para cada ação",
  "match.now": "Agora",
  "match.next": "Próxima",
  "match.done": "Fim da build",
  "match.exit": "Sair do modo partida",
  "match.workers": "Aldeões agora",
  "match.notStarted": "A build ainda não começou.",
  "settings.language": "Idioma",
  "settings.theme": "Tema",
  "settings.themeLight": "Claro",
  "settings.themeDark": "Escuro",
  "settings.themeSystem": "Sistema",
  "settings.efficiency": "Eficiência padrão",
  "settings.sound": "Som no modo partida",
  "settings.on": "Ligado",
  "settings.off": "Desligado",
  "settings.data": "Base de dados",
  "settings.patch": "Patch do jogo",
  "settings.api": "API estática",
  "step.byUnit": "1 {unit}",
  "row.builderUnit": "Soldado",
  "warn.cannotBuild": "{unit} não constrói {building}",
  "warn.noUnitToBuild": "Nenhum {unit} disponível; esperou {waited} s",
  "settings.tooltips": "Dicas de ajuda",
  "help.library.new": "Cria uma build vazia e abre o editor.",
  "help.library.import": "Carrega builds de um arquivo .json exportado por este site.",
  "help.library.exportAll": "Baixa todas as suas builds num único arquivo .json (backup).",
  "help.library.all": "Remove o filtro de panteão e de deus.",
  "help.library.drop": "Arraste arquivos .json para cá para importar builds.",
  "help.library.mine": "Builds criadas por você, salvas neste navegador.",
  "help.library.presets": "Builds prontas que vêm com o site. Só leitura: duplique para editar.",
  "help.type.rush": "Ataque cedo para pressionar o adversário.",
  "help.type.eco": "Foco em economia: muitos aldeões antes de lutar.",
  "help.type.timing": "Ataque forte num momento planejado (ex.: logo após subir de Era).",
  "help.type.water": "Build para mapas de água (pesca e navios).",
  "help.type.other": "Qualquer outro tipo de build.",
  "help.editor.objective": "O plano da build em poucas palavras: o que ela busca fazer.",
  "help.editor.end": "Onde a build termina: um ataque, uma Era, uma tropa. Depois disso o jogo é livre.",
  "help.editor.settings": "Parâmetros da simulação desta build. Vazio = valor padrão.",
  "help.editor.efficiency": "Quanto da taxa de coleta teórica os aldeões realmente rendem (caminhada, depósito). 1 = 100%.",
  "help.editor.tick": "Passo da simulação em segundos. Menor = mais preciso e mais lento.",
  "help.editor.oracleRate": "Favor por minuto de cada Oráculo (0,6 andando a 3,4 parado com visão livre). O herói rende 44% a mais.",
  "help.editor.norseFavor": "Os nórdicos ganham favor lutando. Estime aqui o favor por minuto vindo de combate.",
  "help.editor.foodChain": "Ordem das fontes de comida. Aldeões mandados para “comida” usam a primeira que ainda tiver recurso.\n• **Arraste** para reordenar.\n• **Caça, rebanho e frutas** podem entrar de novo (ex.: uma segunda caça), cada uma com a sua quantidade.\n• Quando uma acaba, a build ganha um passo automático para mandar os aldeões para a próxima.",
  "help.editor.actions": "Os passos da build em ordem, cada um com sua barra no tempo: tracejado é espera, losango é instantâneo. Arraste pela alça para reordenar, arraste a barra para mudar o horário, clique para ver os detalhes.",
  "help.editor.add": "Escolha o tipo de ação e depois a unidade, prédio ou pesquisa. Clique para pôr no fim, ou arraste para uma posição da lista.",
  "help.editor.milestones": "Momentos importantes: tempo e recursos em cada um.",
  "help.editor.matchups": "Como a build se sai contra cada deus. Arraste os retratos entre as colunas, ou clique para trocar a avaliação.",
  "help.palette.allAges": "Mostra itens de todas as Eras. Use os ícones para filtrar por Era.",
  "help.action.train": "Treina unidades num prédio. O custo é pago quando cada unidade começa.\n**Modo**:\n• **quantidade fixa**: N unidades\n• **fila automática**: sem parar pelo tempo em **Por**",
  "help.action.train.auto": "Fila automática: o prédio treina a unidade sem parar enquanto houver recursos.\n• Gasta o que estiver disponível, mesmo que atrase outras ações.\n• Nenhuma outra ação a segura: sempre que o prédio estiver livre e houver recursos, treina mais uma.\n• Fica ligada pelo tempo em **Por** (ou até o fim da build).",
  "help.action.build": "Constrói um prédio com um ou mais aldeões.",
  "help.action.research": "Pesquisa uma tecnologia num prédio.",
  "help.action.age": "Sobe de Era escolhendo o deus menor.",
  "help.action.move": "Muda aldeões de um recurso para outro.",
  "help.action.power": "Usa um poder divino.",
  "help.action.timeShift": "Move um prédio pronto para outro lugar. Leva o tempo de construção dele; Palácio, Torre Sentinela e Torre Espelho custam 50% do preço. No máximo 2 ao mesmo tempo.",
  "help.action.promote": "Transforma uma unidade em outra.",
  "help.action.event": "Algo que a simulação não calcula: perder unidades num ataque, ganhar favor ou recursos, ou uma nota.",
  "help.row.when": "Quando a ação começa: num tempo fixo, logo depois de outra ação, ou assim que der a partir de outra ação.",
  "help.row.count": "Quantas unidades (ou aldeões).",
  "help.row.rally": "Para onde os aldeões vão ao sair do prédio.",
  "help.row.target": "Qual prédio recebe o efeito.",
  "help.row.trainAt": "Em qual prédio treinar. “Qualquer” usa o primeiro livre.",
  "help.row.builder": "Quem constrói, como você escolhe no jogo:\n• **Tirar de…**: um aldeão que está coletando um recurso (ou ocioso).\n• **Aldeão novo de…**: um que saiu de um treino anterior.\n• **Mesmo construtor de…**: quem fez uma construção anterior.\n• **Soldado**: uma unidade militar que constrói (ex.: infantaria nórdica).",
  "help.row.unit": "Qual unidade.",
  "help.row.trainMode": "Como o treino continua:\n• **Quantidade fixa**: treina N unidades e termina.\n• **Fila automática**: treina sem parar enquanto houver recursos, pelo tempo em **Por**; pode atrasar outras ações.",
  "help.row.from": "De qual recurso os aldeões saem.",
  "help.row.to": "Para qual recurso os aldeões vão.",
  "help.row.then": "Para onde o construtor vai quando terminar.",
  "help.row.nearManor": "Cronos: quantas Mansões estão perto do prédio. Cada uma acelera a construção em 25%.",
  "help.row.minor": "O deus menor escolhido nesta subida de Era.",
  "help.row.lose": "Unidades perdidas (ex.: num raid). Liberam população.",
  "help.row.gainFavor": "Favor ganho de uma vez (ex.: luta dos nórdicos).",
  "help.row.note": "Um lembrete que aparece na linha do tempo.",
  "help.row.mode.time": "Começa no tempo indicado (m:ss).",
  "help.row.mode.asap": "Começa assim que for possível (recursos, prédio livre) a partir de um momento de outra ação:\n• **quando ela termina**\n• **quando ela começa**\nEsperar aqui é normal: não conta como atraso.",
  "help.row.mode.after": "Começa logo num momento de outra ação, mais o atraso:\n• **quando ela termina**: Era alcançada, prédio pronto, unidades prontas…\n• **quando ela começa**\nSe tiver que esperar recursos, é atraso.",
  "help.result.timeline": "A build segundo a segundo: tempo, ações, população e aldeões em comida/madeira/ouro/favor.",
  "help.result.warnings": "Problemas encontrados na simulação. Clique num aviso para ir à ação.",
  "help.result.resources": "Recursos guardados ao longo do tempo.",
  "help.result.population": "População usada e limite ao longo do tempo.",
  "help.result.clicked": "Momento em que a pesquisa da Era foi clicada.",
  "help.result.reached": "Momento em que a nova Era chegou.",
  "help.result.good": "Confrontos em que a build é forte.",
  "help.result.neutral": "Confrontos equilibrados.",
  "help.result.bad": "Confrontos em que a build sofre.",
  "help.level.error": "A ação não pode acontecer como está (falta pré-requisito, id errado…).",
  "help.level.delay": "A ação atrasou: faltou recurso, fila ocupada, população cheia…",
  "help.level.info": "Informação: dado de baixa confiança, coleta que a unidade não faz…",
  "help.match.countdown": "Segundos de contagem antes do 0:00, para sincronizar com o início da partida.",
  "help.match.now": "O passo atual da build.",
  "help.match.next": "As próximas 3 ações e quanto falta para cada uma.",
  "help.match.reset": "Volta o relógio ao início.",
  "help.settings.language": "Idioma do site.",
  "help.settings.theme": "Claro, escuro ou igual ao sistema.",
  "help.settings.efficiency": "Eficiência usada nas builds novas.",
  "help.settings.sound": "Bipe no modo partida 3 s antes de cada passo.",
  "help.settings.tooltips": "Mostra estas explicações ao passar o mouse nos títulos.",
  "help.settings.data": "De onde vêm os números do jogo.",
  "help.settings.patch": "Versão do jogo usada nos dados.",
  "help.settings.api": "Arquivos JSON com as builds padrão e os dados, para outros sites usarem.",
  "tab.details": "Detalhes",
  "help.tab.details": "Tipo, autor, objetivo, fim da build, parâmetros da simulação e confrontos.",
  "production.title": "Produção",
  "help.production.title": "O que cada prédio está fazendo ao longo do tempo: treinos, pesquisas, subida de Era, construção e Time Shift. Passe o mouse numa barra para ver início e fim.",
  "production.zoom": "Zoom",
  "production.building": "Construção: {building}",
  "production.shift": "Time Shift",
  "production.running": "em andamento",
  "production.held": "Pronto, esperando população desde {t}",
  "production.heldLegend": "Esperando população",
  "production.kind.unit": "Treino",
  "production.kind.research": "Pesquisa",
  "production.kind.age": "Era",
  "production.kind.build": "Construção",
  "production.kind.shift": "Time Shift",
  "warn.cannotTimeShift": "Este prédio não pode receber Time Shift: {building}",
  "warn.timeShiftLimit": "Máximo de {count} Time Shifts ao mesmo tempo; esperou {waited} s",
  "action.promote.atlanteans": "Promover a herói",
  "help.action.promote.atlanteans": "Transforma a unidade em herói: mais forte; o Cidadão herói coleta e constrói mais rápido. O aldeão para de coletar durante os 7 s da promoção.",
  "help.action.promote.gaia": "Transforma a unidade em herói. Gaia: o Cidadão herói custa 25% menos. O aldeão para de coletar durante os 7 s da promoção.",
  "action.promote.norse": "Virar Berserker",
  "help.action.promote.norse": "Transforma um Coletor (30 comida + 20 ouro) ou um Anão (10 comida + 30 ouro) em Berserker, na hora. Ele deixa de coletar e entra no exército. Precisa de 1 espaço livre de população (o Berserker ocupa 2).",
  "help.action.promote.loki": "Transforma um Coletor ou Anão em Berserker, na hora. Loki: metade do preço (Coletor 15 comida + 10 ouro; Anão 5 comida + 15 ouro). Precisa de 1 espaço livre de população (o Berserker ocupa 2).",
  "help.action.build.norse": "Constrói um prédio. Coletores e Anões só constroem Casa, Fazenda e Carroça de Boi; o resto é construído pela infantaria (escolha o construtor “Soldado”).",
  "help.row.builder.norse": "Quem constrói: Automático, Tirar de um recurso, Aldeão novo de um treino anterior, Mesmo construtor de uma construção anterior, ou um Soldado (Berserker, Hersir…) para os prédios que Coletores e Anões não constroem.",
  "action.empower": "Fortalecer",
  "action.summon": "Invocar animal",
  "step.empower": "Fortalecer {building} ({unit})",
  "step.summon": "Invocar {count} {unit}",
  "step.hunted": "{unit} caçado: +{food} de comida na caça",
  "row.by": "Quem",
  "row.slot": "Qual (nº)",
  "row.huntIt": "Caçar",
  "warn.cannotEmpower": "{unit} não pode fortalecer {building}",
  "warn.noUnitToEmpower": "Nenhum {unit} disponível para fortalecer; esperou {waited} s",
  "warn.cannotSummon": "Este deus não invoca {unit}",
  "warn.notForGod": "Este deus não tem: {id}",
  "help.action.empower": "O Faraó fortalece um prédio por vez: construção, pesquisa (inclusive subir de Era) e treino militar ×1,75; recursos entregues no depósito ×1,2; favor do Monumento ×1,2. Aldeões, barcos de pesca e caravanas não treinam mais rápido.",
  "help.action.empower.ra": "Rá: o Faraó fortalece um prédio por vez (construção, pesquisa e treino militar ×1,75; depósito e favor de Monumento ×1,2) e cada Sacerdote também fortalece um prédio com 60% do efeito (×1,45 e ×1,12). Os efeitos não somam: no mesmo prédio vale o mais forte.",
  "help.action.empower.isis": "Ísis: o Faraó fortalece um prédio por vez (construção, pesquisa e treino militar ×1,75; depósito ×1,2). Um Monumento fortalecido gera o dobro de favor (×2).",
  "help.action.summon": "Invoca um animal com favor.",
  "help.action.summon.set": "Set: o Faraó invoca Animais de Set com favor (Babuíno 3, Gazela 3, Girafa 5…). Marque “Caçar” para matar o animal e mandar a comida dele para a caça (Gazela 150, Girafa 300).",
  "help.row.by": "Quem fortalece: o Faraó.",
  "help.row.by.ra": "Quem fortalece: o Faraó (efeito total) ou um Sacerdote (60% do efeito).",
  "help.row.slot": "Qual Faraó/Sacerdote (1, 2, …). Cada um fortalece um prédio; fortalecer outro troca o anterior.",
  "help.row.huntIt": "Mata o animal assim que ele surge: não ocupa população e a comida dele vai para a caça.",
  "help.action.train.greeks": "Treina unidades num prédio. Heróis gregos têm fila própria: podem ser treinados sem parar os aldeões nem a subida de Era.\n**Modo**:\n• **quantidade fixa**: N unidades\n• **fila automática**: sem parar pelo tempo em **Por**",
  "help.action.research.thor": "Pesquisa uma tecnologia. Thor: não tem Armaria; cada pesquisa da Armaria de Anões dá 1 Anão grátis.",
  "help.action.build.loki": "Constrói um prédio. Coletores e Anões só constroem Casa, Fazenda e Carroça de Boi; o resto é construído pela infantaria, que com Loki constrói 10% mais rápido.",
  "editor.undo": "Desfazer (Ctrl+Z)",
  "editor.redo": "Refazer (Ctrl+Y)",
  "row.builderNewFrom": "Treino de origem",
  "row.builderSameAs": "Construção anterior",
  "row.invalidRef": "ação que não existe antes desta",
  "help.row.builderNewFrom": "Qual treino anterior entrega o aldeão que vai construir. A ação espera esse aldeão ficar pronto (ex.: “Treinar 3 Cidadãos” → o próximo que sair vai construir).",
  "help.row.builderSameAs": "Qual construção anterior: o mesmo aldeão que a fez constrói esta assim que terminar a outra.",
  "nav.close": "Fechar",
  "editor.more": "Mais",
  "tab.gods": "Deuses",
  "tab.actions": "Ações",
  "tab.result": "Resultado",
  "help.tab.gods": "Escolha o panteão, o deus maior e um deus menor por idade.",
  "help.tab.actions": "Monte a build com a paleta. Cada ação mostra quando começa na simulação.",
  "help.tab.result": "Marcos, o que cada prédio produz e os gráficos de recursos e população.",
  "help.editor.minors": "O deus menor escolhido ao avançar para cada idade.",
  "editor.start": "Início da partida",
  "editor.startIdle.one": "{count} aldeão inicial está ocioso: use Mover (de ocioso).",
  "editor.startIdle.other": "{count} aldeões iniciais estão ociosos: use Mover (de ocioso).",
  "warn.idleUntilEnd.one": "{count} aldeão ficou ocioso até o fim",
  "warn.idleUntilEnd.other": "{count} aldeões ficaram ociosos até o fim",
  "help.production.zoom": "Zoom a partir da build inteira na tela: 2× deixa tudo duas vezes mais largo (metade da build cabe na tela), 4× quatro vezes.",
  "palette.group.economy": "Economia",
  "palette.group.god": "Do deus",
  "palette.group.other": "Outros",
  "help.palette.group.economy": "O básico de toda build: mover aldeões, treinar (quantidade fixa ou fila automática), construir, pesquisar e subir de Era.",
  "help.palette.group.god": "Poderes e ações que dependem do deus escolhido.",
  "help.palette.group.other": "Anotações na linha do tempo, como um ataque ou uma perda de unidades.",
  "wd.waited": "Esperou {waited} s",
  "wd.need": "Custo",
  "wd.have": "Tinha em {t}",
  "wd.missing": "Faltavam",
  "wd.gathering": "Coletando",
  "wd.gatherers.one": "{count} aldeão",
  "wd.gatherers.other": "{count} aldeões",
  "wd.spent": "Gastos de {resource} durante a espera",
  "wd.noSpent": "Nenhum: a espera foi só coleta.",
  "wd.other": "Outros",
  "wd.onlyGathering": "Só coletando, os {missing} de {resource} que faltavam levam ~{s} s.",
  "wd.spentDelay": "Os gastos acima ({total}) somaram ~{s} s à espera.",
  "wd.goTo": "Ir para a ação",
  "help.warn.noResource": "A ação estava pronta, mas o estoque não pagava o custo; ela espera a coleta cobrir o que falta. Para adiantar: ponha mais aldeões nesse recurso mais cedo ou gaste menos dele antes.",
  "help.warn.queueBusy": "O prédio estava ocupado treinando ou pesquisando outra coisa; a ação começa quando a fila liberar.",
  "help.warn.popCapped": "A unidade ficou pronta, mas a população estava no limite: ela só sai quando houver espaço. Aumente a população antes.",
  "help.warn.waitingRequirement": "A ação depende de algo que ainda não estava pronto (prédio, idade ou pesquisa) e esperou por isso.",
  "help.warn.missingRequirement": "Falta um requisito (prédio, idade ou deus menor) que a build nunca cria; a ação não começa.",
  "help.warn.idleWorkers": "Aldeões ficaram sem tarefa nesse período. Use Mover para mandá-los coletar.",
  "help.warn.idleUntilEnd": "Aldeões ficaram sem tarefa até o fim da simulação. Use Mover (de ocioso) para mandá-los coletar.",
  "help.warn.neverStarted": "A ação nunca começou até o fim da simulação. O motivo indicado é o que a segurava por último.",
  "help.warn.lowConfidenceData": "Algum número usado aqui é incerto nos dados; o resultado pode variar na partida real.",
  "help.warn.waitingBuilder": "Nenhum construtor estava livre; a construção esperou alguém terminar.",
  "help.warn.notEnoughWorkers": "Pediu para mover mais aldeões do que havia nessa tarefa naquele momento.",
  "help.warn.powerCooldown": "O poder ainda estava recarregando desde o último uso.",
  "editor.matchupPool": "Deuses sem avaliação",
  "editor.clearMinorLater": "Remover a subida de idade também remove as idades seguintes ({ages}). Continuar?",
  "help.editor.chainItem": "Arraste para mudar a prioridade (ou use ← →). Arraste para baixo, fora da lista, para remover.",
  "help.editor.matchupGod": "Muda a avaliação ou a ordem:\n• **Clique**: troca a avaliação.\n• **Arraste para uma coluna**: vai para o fim dela.\n• **Arraste sobre outro deus** ou use **← →**: muda a ordem dentro do grupo.",
  "help.editor.minorChosen": "Escolhido. Clique de novo para tirar (a build não chega a essa idade).",
  "help.editor.minorPick": "Clique para escolher este deus menor ao subir de idade.",
  "tl.workers": "Aldeões",
  "tl.stock": "Estoque",
  "tl.building": "construindo",
  "tl.lanes": "Prédios",
  "tl.fit": "Ajustar",
  "tl.dragHint": "Arraste para mudar o horário",
  "help.tl.workers": "O que os aldeões estão fazendo ao longo do tempo, por recurso. Passe o mouse para ver os números e a população.",
  "help.tl.lanes": "Uma linha por prédio com o que ele treina, pesquisa ou constrói, no mesmo eixo de tempo.",
  "help.tl.fit": "Mostra a build inteira na largura da tela.",
  "step.depletedIdle": "{source} esgotou → aldeões ociosos",
  "warn.sourceDepletedIdle": "{source} esgotou → aldeões ociosos",
  "help.warn.sourceDepletedIdle": "A fonte acabou e não há outra comida disponível na cadeia: os aldeões ficam parados até você mandá-los para outra coisa.",
  "help.mode.view": "A build inteira de uma vez: linha do tempo, recursos e aldeões, sem editar nada.",
  "help.mode.edit": "Monte ou mude a build: ações, deuses, ajustes.",
  "help.mode.play": "Acompanhe a build durante a partida com um cronômetro.",
  "help.overview.full": "Marcado, mostra tudo:\n• linha do tempo com aldeões e eventos\n• produção por prédio\n• recursos e população\nDesmarcado: só as Eras e a ordem das ações.",
  "help.match.workers": "Onde os aldeões deveriam estar agora, segundo a build, e a população. Compare com o jogo para ver se esqueceu algo.",
  "help.row.duration": "Quanto tempo a fila automática fica ligada, em segundos, contando de quando a ação começa.\n• **Vazio**: até o fim da build.",
  "editor.chainAmount": "Quantidade",
  "help.editor.chainAgain": "Clique para pôr de novo na cadeia: ex. uma segunda caça, com a quantidade dela.",
  "step.shift": "{source} esgotou: {count} {worker} → {next}",
  "step.shiftAgain": "{source} esgotou: {count} {worker} → próxima {source}",
  "step.auto": "manual no jogo",
  "help.step.auto": "Passo automático: o simulador já faz isso sozinho quando a fonte acaba, por isso não está na lista de ações.\n• **No jogo** os aldeões não vão sozinhos: selecione-os e mande-os você.\n• A simulação considera que você fez isso na hora.",
  "editor.events": "Eventos",
  "help.editor.events": "Mostra entre as ações o que acontece sozinho: unidades prontas, prédios concluídos, Eras alcançadas.\n• Os passos automáticos (✋, ex.: caça esgotou) aparecem sempre: no jogo você precisa fazê-los.",
  "row.powerNote": "Como usar",
  "help.row.powerNote": "Uma observação de como usar o poder, mostrada junto da ação na build e no Modo partida.\n• Ex.: em qual unidade, prédio ou lugar.",
  "row.powerNoteExample": "ex.: num cidadão coletando ouro",
  "match.previous": "Anterior",
  "help.match.previous": "O passo que acabou de passar: se você está um pouco atrasado, ele ainda está aqui.",
  "help.oss.repo": "Código, dados do jogo e histórico do projeto. Uma estrela ajuda o projeto a ser encontrado.",
  "help.oss.issue": "Abre uma issue no GitHub: um erro nos números, algo que não funciona ou uma ideia nova."
}
